<template>
  <div id="page-alldemands" class="d-flex">
    <MainBarMenu />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid div1 mt-5">
      <div class="row mt-5 mt-md-5">
        <div class="col-12 col-md-8">
          <h2 class="mt-0 mt-md-3 mt-lg-4">Procesos</h2>
        </div>
        <!-- .col -->
        <div class="col-12 col-md-4 text-left text-lg-right mb-3">
          <div
            class="cont-search d-flex flex-column align-items-start align-items-md-end"
          >
            <label for="filter d-block">Busca un proceso por cédula</label>
            <div class="cont-input d-flex">
              <input
                type="text"
                class="input-text"
                v-model="ccFilter"
                placeholder="Introduce tu búsqueda..."
              />
              <button class="d-flex align-items-center px-3" @click="search">
                <span>Buscar</span>
                <span class="icon icon-search ml-3"></span>
              </button>
            </div>
            <button class="btn btn-link" @click="restore">Mostrar todos</button>
            <button class="btn btn-link" @click="exportExcel">
              Exportar a excel
            </button>
          </div>
        </div>
        <!-- .col -->
      </div>

      <!-- .row -->
      <div v-if="loading" id="loader"></div>
      <div v-else>
        <div class="data-table row mt-5">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Cédula</th>
                    <th scope="col">Solicitante</th>
                    <th scope="col">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="process in processesFilter" :key="process.id">
                    <td>{{ process.id }}</td>
                    <td>{{ process.created_at.substring(0, 10) }}</td>
                    <td>{{ process.core_employee.cc }}</td>
                    <td>{{ process.core_employee.name }}</td>
                    <td>
                      <router-link
                        v-if="process.proce_state.id > 1"
                        :to="
                          '/process/' +
                          process.proce_report_id +
                          '/' +
                          process.id
                        "
                      >
                        {{ process.proce_state.name }}
                      </router-link>
                      <span v-else>
                        {{ process.proce_state.name }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row text-left cont-pagintation">
          <div class="col">
            <p class="text-1">
              Mostrando {{ actualPage }} - {{ processesPerPage }} de
              {{ processFilter.length }} Solicitudes
            </p>
          </div>
        </div>
        <!-- Paginador -->
        <div class="row justify-content-center">
          <div class="col-sm-4">
            <div class="text-center">
              <button
                class="btn btn-outline-info mx-1 w-40"
                @click.prevent="previousPage"
                :disabled="!isPrevious"
              >
                Atrás
              </button>
              <button
                class="btn btn-outline-info mx-1 w-40"
                @click.prevent="nextPage"
                :disabled="!isNext"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- .row -->
      <div class="mb-menu"></div>
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-alldemands -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
// import XLSX from "xlsx";

export default {
  name: "AllProcess",
  components: {
    MainBarMenu,
    HeadingUser,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      ccFilter: "",
      processesPerPage: 10,
      actualPage: 1,
      processFilter: [],
    };
  },
  async beforeMount() {
    await this.actGetProcesses();
    this.processFilter = this.processes;
  },
  computed: {
    ...mapState("modProcessEmployee", ["processes", "loading"]),
    processesFilter2() {
      return this.processes.filter((process) => {
        return (
          process.core_employee.cc.includes(this.ccFilter) || !this.ccFilter
        );
      });
    },
    processesFilter() {
      let start = (this.actualPage - 1) * this.processesPerPage;
      let end = start + this.processesPerPage;
      return this.processFilter.slice(start, end);
    },
    isPrevious() {
      return this.actualPage !== 1;
    },
    isNext() {
      let lastPage = Math.ceil(
        this.processFilter.length / this.processesPerPage
      );
      return this.actualPage !== lastPage;
    },
  },
  methods: {
    ...mapActions("modProcessEmployee", ["actGetProcesses"]),
    previousPage() {
      if (this.isPrevious) {
        this.actualPage = this.actualPage - 1;
      }
    },
    nextPage() {
      if (this.isNext) {
        this.actualPage = this.actualPage + 1;
      }
    },
    search() {
      if (this.ccFilter) {
        this.actualPage = 1;
        this.processFilter = this.processes.filter((process) => {
          return (
            process.core_employee.cc.includes(this.ccFilter) || !this.ccFilter
          );
        });
      }
    },
    restore() {
      this.actualPage = 1;
      this.processFilter = this.processes;
      this.ccFilter = "";
    },
    exportExcel: function () {
      // let json = this.processFilter.map((employee) => {
      //   return {
      //     id: employee.id,
      //     created_at: employee.created_at.substring(0, 10),
      //     cc: employee.core_employee.cc,
      //     name: employee.core_employee.name,
      //     state: employee.proce_state.name,
      //   };
      // });

      // let data = XLSX.utils.json_to_sheet(json);
      // const workbook = XLSX.utils.book_new();
      // const filename = "processes";
      // XLSX.utils.book_append_sheet(workbook, data, filename);
      // XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>

<style lang="scss">
#page-alldemands {
  .data-table {
    tr {
      th {
        &:nth-child(1) {
          min-width: 120px;
        }
        &:nth-child(2) {
          min-width: 170px;
        }
        &:nth-child(3) {
          min-width: 110px;
        }
        &:nth-child(4) {
          min-width: 210px;
        }
        &:nth-child(5) {
          min-width: 110px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#page-alldemands {
  .cont-search {
    label {
      font-size: 11px;
      color: #454545;
    }
    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;
        &:focus {
          outline: none;
        }
      }
      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }
  .button1 {
    font-family: "Open Sans";
    background: #e9ecee;
    color: #1c3a4e;
    font-weight: bold;
    //border-radius: 50px;
    height: 32px;
    font-size: 14px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    outline: none;
    border: none;
    &:hover {
      background: darken(#cddce6, 5);
      border: none;
    }
  }
  .div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 40px;
    margin-left: 40px;
  }
  .tabla1 {
    border-radius: 5px;
    border: 3px solid #e9ecee;
    border-color: #e9ecee;
    background: #e9ecee;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 100%;
    padding-left: 5%;
    align-self: left;
  }
  .td1 {
    background: #e9ecee;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    padding-left: 0%;
    padding-right: 3%;
    width: 100px;
    text-align: left;
  }
  .td2 {
    background: #e9ecee;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 14px;
    //width: 50px;
    text-align: left;
    padding-left: 0%;
    padding-right: 3%;
    padding-top: 10px;
  }
  .td3 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 40px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td4 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: left;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    color: #454545;
    text-align: left !important;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }
  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
}

.btn-outline-info {
  color: #1c3a4e !important;
  border-color: #1c3a4e !important;
  font-size: 14px;
  line-height: 21px;
}

.btn-outline-info:hover {
  background-color: #1c3a4e !important;
  color: #fff !important;
}
</style>